import { FormControl, Button, H3 } from '@ouster/webviz-react-components';

import { FormEvent, useRef } from 'react';

import styles from './Organization.module.css';
import { UserOrg } from '../../types';
import { isAdminLevelRole } from '../../utils/roles';

type OrganizationNameProps = {
  curUserOrg: UserOrg;
  updateOrgNameHandler: (name: string) => void;
};

export default function OrganizationName({
  curUserOrg,
  updateOrgNameHandler,
}: OrganizationNameProps) {
  const orgNameRef = useRef<HTMLInputElement>(null);

  const hasPermission = isAdminLevelRole(curUserOrg?.role);

  function handleOrgNameChange(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (orgNameRef.current?.value)
      updateOrgNameHandler(orgNameRef.current.value);
  }

  if (!curUserOrg) {
    return null;
  }

  return (
    <div className={styles['section-container']} data-testid="org-name-section">
      <H3
        fontSize={16}
        textTransform="uppercase"
        className={styles.heading}
        data-testid="org-name-heading"
      >
        Organization Name
      </H3>
      <form onSubmit={handleOrgNameChange} data-testid="org-name-form">
        <FormControl paddingInline={0}>
          <div className={styles['inline-form']}>
            <input
              type="text"
              required
              className={styles['form-input']}
              defaultValue={curUserOrg.name}
              disabled={!hasPermission}
              ref={orgNameRef}
              data-testid="org-name-input"
            />
            {hasPermission && (
              <Button
                variant="outline"
                minWidth={150}
                type="submit"
                data-testid="org-name-submit"
              >
                Change Name
              </Button>
            )}
          </div>
        </FormControl>
      </form>
    </div>
  );
}
